/**
 * Параметры алгоритма сборки отрядов v1 (BLUEPRINT Stage 10, раздел 3.5).
 * Только числа: сами функции — в `domain/matching/*`, тексты объяснений — в `texts.ts` админки.
 */
export const MATCHING = {
  /** Жёсткое ограничение по уровню: |level − seed| ≤ levelSpread */
  levelSpread: 1,
  /** Жёсткое ограничение по возрасту: |age − seedAge| ≤ ageSpread */
  ageSpread: 7,
  /** Скор надёжности, ниже которого начинается штраф (стартовое значение `User.reliability`) */
  reliabilityBase: 70,
  /** Размер отряда, для которого штраф за низкую надёжность удваивается (ADR-9: пара) */
  smallSquadSize: 2,
  /** Ячейка «стоит»: столько дней без движения — повод предложить переход из меньшей ячейки */
  stalledCellDays: 14,
  /** Кандидат ждёт слишком долго: столько дней в пуле — уведомление «смени вечер / район» */
  longWaitDays: 14,
  /** Как часто крутится job `matching.run`, часов */
  runEveryHours: 6,
  /** Сколько предложений на город сохраняем за один прогон */
  maxProposalsPerRun: 20,
  weights: {
    /** Близость района: общий район / соседний (0–3) */
    districtShared: 3,
    districtSharedOne: 2,
    districtNeighbor: 1,
    /** Плотность доступности: за каждый общий вечер сверх обязательного, не больше максимума */
    availabilityPerDay: 1,
    availabilityMax: 3,
    /** Близость уровня: тот же уровень / соседний */
    levelExact: 2,
    levelNear: 1,
    /** Взаимное «сыграл бы ещё» с уже отобранным участником */
    wouldPlayAgainMutual: 4,
    /** Односторонняя отметка «сыграл бы ещё» */
    wouldPlayAgainOneWay: 1,
    /** Реферальная пара держится вместе */
    referralPair: 5,
    /** Штраф за каждый балл надёжности ниже `reliabilityBase` */
    reliabilityPenaltyPerPoint: 0.2,
    /** Множитель штрафа для отряда размера `smallSquadSize` */
    smallSquadPenaltyFactor: 2,
    /** Бонус за приоритет заявки (рефералы, повторные, автор предложенной активности) */
    priority: 2,
  },
} as const;

export type MatchingConstants = typeof MATCHING;

/** Коды объяснений «почему вместе» — подписи в `texts.ts` админки. */
export const MATCH_REASON_CODES = [
  'district',
  'availability',
  'level',
  'wouldPlayAgain',
  'referral',
  'reliability',
  'priority',
] as const;

export type MatchReasonCode = (typeof MATCH_REASON_CODES)[number];
